import React from "react";
import { Text } from "@chakra-ui/react";
import styled from "styled-components";

const ErrorMessageText = styled(Text)`
  /* color: ${({ theme }) => theme.colors.redMedium}; */
`;

export default ErrorMessageText;
